import type { KioskFlowRepository } from '../data/kiosk-flow-repository';
import type { KioskFlowOperatorContext } from '../types/kiosk-flow-types';
import { assertOperator } from './flow-validation';

export class DeleteKioskFlowUseCase {
  constructor(private readonly repository: KioskFlowRepository) {}

  // Backoffice-only delete — kiosks keep their last published flow
  async execute(ctx: KioskFlowOperatorContext): Promise<void> {
    assertOperator(ctx);
    return this.repository.deleteFlow(ctx);
  }
}
